export default "__VITE_ASSET__CsquSUJ8__"